import React, { FC, createRef, useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import st from "./index.module.scss";
import { Button } from "@pepdirect/ui/button";
import { useRouter } from "next/router";
import { useOnScreen } from "@pepdirect/helpers/useOnScreen";
import {
  generateHashedId,
  logInternalPromotionSelect,
  logInternalPromotionView,
} from "@pepdirect/helpers/analyticsLogger";

const texts: string[] = [
  "So You Can Focus",
  "Energy & Mental Boost*",
  "Zero Calories. Zero Sugar. 100% Refreshing Flavor",
  "So You Can Be In the Moment",
];

export const FocusPageFocusFor: FC = () => {
  const router = useRouter();
  const ref = createRef<HTMLDivElement>();
  const isVisible = useOnScreen(ref);

  const settings = {
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    arrows: false,
    pauseOnHover: false,
    className: st.box,
  };

  const [isEventTriggered, setIsEventTriggered] = useState<boolean>(false);

  const promotionEventParams = useMemo(() => {
    const promotionName = "new focus launch";
    const promotionId = generateHashedId(promotionName);

    return {
      creativeName: "focus landing|text carousel|focus|01-2024",
      promotionName,
      promotionId,
      creativeSlot: "focus landing|text carousel|new launch|middle|5",
    };
  }, []);

  useEffect(() => {
    if (isVisible && !isEventTriggered) {
      setIsEventTriggered(true);
      logInternalPromotionView("", promotionEventParams);
    }
  }, [isEventTriggered, isVisible, promotionEventParams]);

  return (
    <div className={st.container} ref={ref}>
      <div className={st.text}>ROCKSTAR FOCUS®</div>
      <Slider {...settings}>
        {texts.map((text) => (
          <div key={text} className={st.boxText}>
            <p>{text}</p>
          </div>
        ))}
      </Slider>
      <Button
        onClick={() => {
          logInternalPromotionSelect("", promotionEventParams);
          router.push({
            pathname: "/shop-all",
            hash: "products",
            query: {
              canSize: "All",
              nutrition: "All",
              subline: "Focus",
              unAvailableProducts: "show",
            },
          });
        }}
      >
        Shop now
      </Button>
    </div>
  );
};
